module.exports = __webpack_public_path__ + "img/aboutus_3.f2f3523f.png";